import Settings from './settings'

export default {
  ...Settings,
  urlHotFolder: 'https://hotfolder.idoccar.com/api/',
  webSocketUrl: 'wss://qa.vgrs.idoccar.com:8007',
  notificationRefresh: 60000,
  showSignDocumentButton: false,
  acceptFileFormats: 'application/pdf, .jpg, .png, .jpeg, .gif, .docx, .doc, .xls, .xlsx, .ppt, .pptx, .msg, .tiff',
  qaSite: true,
  dealerMaxLength: 7,
  dealerNumberRegex: null,
  clientFieldValidation: 'vgr',
  autoLoadDashboard: false,
  validateLicensePlate: /(E\d{4}[A-Z]{3})|([A-Z]{1,2}\d{4}[A-Z]{2})|(E[A-Z]{1,2}\d{6})|([CH]{1}\d{4}[A-Z]{1,3})|(CD\d{4,5})|(CC\d{4,5})$/g,
  maxTagCount: 2,
  maxTagTextLength: 10,
  matomoSiteId: '34',
  orderDateLimitHour: '12',
  enableFavoritesAndRecents: true,
  enableTaskFollowUp: true,
  dashboardVersion: 2,
  usersManualUrl: 'https://formacion-new.idoccar.com/',
  usersManualEnvironment: 'pre-vgrs',
  environmentName: 'pre-vgrs',
  paymentGatewayUrl: 'https://canales.redsys.es/admincanales-web/index.jsp#/login',
  showV2Link: true
}
